module.exports = {"520603001":"谢桥街道","520603002":"茶店街道","520603003":"仁山街道","520603100":"万山镇","520603200":"高楼坪侗族乡","520603201":"黄道侗族乡","520603202":"敖寨侗族乡","520603203":"下溪侗族乡","520603204":"鱼塘侗族苗族乡","520603205":"大坪侗族土家族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520603.json
// module id = 2305
// module chunks = 0